const DEFAULT_VISIT_FEEDBACK_DISPLAY_CONFIG = Object.freeze({
  showAiOptimizedContent: true,
});

// Feedback presentation is intentionally configured independently from the AI
// processing switch. Hiding optimized content must not disable compliance
// analysis, labels, follow-up suggestions, or the data saved to the backend.
export const VISIT_FEEDBACK_DISPLAY_BY_ROLE = Object.freeze({
  GBA: Object.freeze({showAiOptimizedContent: false}),
  GA: Object.freeze({showAiOptimizedContent: false}),
  MR: Object.freeze({showAiOptimizedContent: true}),
  '销售': Object.freeze({showAiOptimizedContent: true}),
});

export function getVisitFeedbackDisplayConfig(roleName = '') {
  const normalizedRoleName = String(roleName || '').trim();
  return {
    ...DEFAULT_VISIT_FEEDBACK_DISPLAY_CONFIG,
    ...(VISIT_FEEDBACK_DISPLAY_BY_ROLE[normalizedRoleName] || {}),
  };
}
